// extracted by mini-css-extract-plugin
export default {"link-list":"styles_link-list__7Omk3","link-item":"styles_link-item__BN+rs","link":"styles_link__5qVOk"};